// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* AdvancePaymentForm.css */

.form-container {
  max-width: 1200px;
  margin: 0 auto;
}

.custom-input {
  width: 85% !important;
  transition: all 0.3s ease;
}

.custom-input:focus {
  width: 90% !important;
  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

/* For even more horizontal spacing between columns */
.row.gy-5 > [class*="col-"] {
  padding-left: 20px;
  padding-right: 20px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .custom-input {
    width: 100% !important;
  }
  
  .custom-input:focus {
    width: 100% !important;
  }
}

.submit-button {
  transition: all 0.3s ease !important;
}

.submit-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Views/CorporateResource/FinanceView/Forms/AdvancePaymentForm.css"],"names":[],"mappings":"AAAA,2BAA2B;;AAE3B;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,qDAAqD;AACrD;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;EAC3B,kDAAkD;AACpD","sourcesContent":["/* AdvancePaymentForm.css */\r\n\r\n.form-container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n.custom-input {\r\n  width: 85% !important;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.custom-input:focus {\r\n  width: 90% !important;\r\n  box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);\r\n}\r\n\r\n/* For even more horizontal spacing between columns */\r\n.row.gy-5 > [class*=\"col-\"] {\r\n  padding-left: 20px;\r\n  padding-right: 20px;\r\n}\r\n\r\n/* Responsive adjustments */\r\n@media (max-width: 768px) {\r\n  .custom-input {\r\n    width: 100% !important;\r\n  }\r\n  \r\n  .custom-input:focus {\r\n    width: 100% !important;\r\n  }\r\n}\r\n\r\n.submit-button {\r\n  transition: all 0.3s ease !important;\r\n}\r\n\r\n.submit-button:hover {\r\n  transform: translateY(-2px);\r\n  box-shadow: 0 4px 12px rgba(0,0,0,0.15) !important;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
